import { render } from "./NumberRange.vue?vue&type=template&id=1bd712c7&scoped=true"
import script from "./NumberRange.vue?vue&type=script&lang=ts"
export * from "./NumberRange.vue?vue&type=script&lang=ts"

import "./NumberRange.vue?vue&type=style&index=0&id=1bd712c7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1bd712c7"

export default script